import React, { useState, Fragment } from 'react'
import { Pagination } from 'antd'

const CustomPagination = ({ dispatch, count, children, current, limit }) => {
  const [page, setPage] = useState(current)
  const [pageLimit, setLimit] = useState(limit)

  const handlePageSize = (_, size) => {
    // change size and reset to first page
    refreshFilesList(1, size)
    setLimit(size)
  }

  const handlePageChange = (newPage, newPageSize) => {
    refreshFilesList(newPage, newPageSize)
    setPage(newPage)
    setLimit(newPageSize)
  }

  const refreshFilesList = (newPage, pageSize) => {
    dispatch({
      type: 'files/LOAD_FILES',
      payload: {
        page: newPage,
        limit: pageSize,
      },
    })
  }

  // Pagination component
  return (
    <>
      <div className="mb-4">
        <Pagination
          defaultCurrent={1}
          current={page}
          total={count}
          pageSize={pageLimit}
          showSizeChanger
          onShowSizeChange={(currentPage, size) => handlePageSize(currentPage, size)}
          onChange={(newPage, newPageSize) => handlePageChange(newPage, newPageSize)}
        />
      </div>
      {children}
      <Pagination
        defaultCurrent={1}
        current={page}
        total={count}
        pageSize={pageLimit}
        showSizeChanger
        onShowSizeChange={(currentPage, size) => handlePageSize(currentPage, size)}
        onChange={(newPage, newPageSize) => handlePageChange(newPage, newPageSize)}
      />
    </>
  )
}

export default CustomPagination
